// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter[data-v-a220c272],.fade-leave-to[data-v-a220c272]{opacity:0}.fade-enter-active[data-v-a220c272],.fade-leave-active[data-v-a220c272]{transition:opacity .5s}", ""]);
// Exports
module.exports = exports;
